export const ScanlineEffect = () => {
  return (
    <div className="pointer-events-none fixed inset-0 z-50 opacity-[0.04]">
      <div
        className="h-full w-full"
        style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(0, 0, 0, 0.6) 1px, rgba(0, 0, 0, 0.6) 2px)',
          animation: 'scanline 15s linear infinite'
        }}
      />
    </div>
  );
};
